import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, FormControlLabel, Radio, RadioGroup, Typography, withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CardSetupForm from './CardSetupForm';
import { CARD, SEPA, START } from './Constants';
import SepaForm from './SepaForm';
import { getClientSecret } from '../../../core/redux/stripe/actions';
import StripeElements from './StripeElements';

const styles = {
  radioGroup: {
    marginTop: 10,
  },
  radio: {
    height: 36,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
};

const Stripe = ({
  isPostalCodeMandatory,
  handleCloseDialog,
  translate,
  dispatch,
  setMopUpdating,
  step,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  classes = {},
  synchronizeMOP,
  resetStripeFlow,
  showSepaOption,
  isFetchingPaymentDetails,
}) => {
  useEffect(() => {
    return () => {
      resetStripeFlow();
    };
  }, []);

  if (isFetchingPaymentDetails) {
    return (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {step === START && (
        <>
          <Typography>{translate('resources.paymentDetails.editPopup.selectPaymentMethod')}</Typography>
          <RadioGroup
            classes={{ root: classes.radioGroup }}
            name="paymentMethods"
            value={selectedPaymentMethod}
            onChange={event => setSelectedPaymentMethod(event.target.value)}
          >
            <FormControlLabel
              classes={{ root: classes.radio }}
              value={CARD}
              control={<Radio />}
              label={translate('resources.paymentDetails.editPopup.card')}
            />
            {showSepaOption && (
              <FormControlLabel
                classes={{ root: classes.radio }}
                value={SEPA}
                control={<Radio />}
                label={translate('resources.paymentDetails.editPopup.sepa')}
              />
            )}
          </RadioGroup>
        </>
      )}
      {step === CARD && (
        <div className="container-fluid">
          <StripeElements>
            <CardSetupForm
              isPostalCodeMandatory={isPostalCodeMandatory}
              translate={translate}
              handleCloseDialog={handleCloseDialog}
              dispatch={dispatch}
              setMopUpdating={setMopUpdating}
              synchronizeMOP={synchronizeMOP}
              resetStripeFlow={resetStripeFlow}
            />
          </StripeElements>
        </div>
      )}
      {step === SEPA && (
        <StripeElements>
          <SepaForm closeDialog={handleCloseDialog} dispatch={dispatch} />
        </StripeElements>
      )}
    </>
  );
};

Stripe.propTypes = {
  isPostalCodeMandatory: PropTypes.bool,
  translate: PropTypes.func,
  handleCloseDialog: PropTypes.func,
  dispatch: PropTypes.func,
  setMopUpdating: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
  selectedPaymentMethod: PropTypes.string,
  setSelectedPaymentMethod: PropTypes.func.isRequired,
  classes: PropTypes.shape({}),
  synchronizeMOP: PropTypes.func.isRequired,
  resetStripeFlow: PropTypes.func.isRequired,
  showSepaOption: PropTypes.bool,
  isFetchingPaymentDetails: PropTypes.bool,
};

const mapActionToProps = dispatch => ({
  startSetupIntentStripe: () => dispatch(getClientSecret({ paymentMethodType: 'CREDIT_CARD' })),
});

const enhance = compose(
  connect(
    null,
    mapActionToProps
  ),
  withStyles(styles)
);

export default enhance(Stripe);
